import React from 'react';
import HeroSection from '../components/HeroSection';
import SliderSection from '../components/SliderSection';
import WhoSection from '../components/WhoSection';
import MessageSection from '../components/MessageSection';
import ServicesSection from '../components/ServicesSection';
import ContactSection from '../components/ContactSection';


const Home: React.FC = () => {

  return (
    <div style={{ margin: 0, padding: 0, display: 'block' }}>
      <HeroSection />
      <SliderSection />      
      <WhoSection />
      <MessageSection />
      <ServicesSection />
      <ContactSection />
    </div>
  );
};

export default Home;
